"use client";
// Las ofertas ya no son una página de catálogo: aparecen mientras compras (carrito, ruta del explorador, ofertas emergentes) y se aplican solas.
import { useEffect } from "react";

export function IrAlCatalogo({ idioma }: { idioma: "es" | "en" }) {
  const es = idioma === "es", destino = `/${idioma}/tours`;
  useEffect(() => { location.replace(destino); }, [destino]);
  return (
    <section className="seccion contenedor">
      <h1>{es ? "Tus descuentos se aplican solos" : "Your discounts apply automatically"}</h1>
      <p className="tenue">{es ? "Elige tus tours y, al reservar o pagar tu carrito, verás cuánto ahorras. Entre más tours, mejor precio." : "Pick your tours and, when you book or pay your cart, you will see how much you save. The more tours, the better the price."}</p>
      <a className="boton" href={destino}>{es ? "Ver tours" : "See tours"}</a>
    </section>
  );
}
